import {
  Alert, Checkbox as MuiCheckBox,
  FormControl,
  FormControlLabel,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
  SelectProps,
  Button,
  Modal,
  Box,
  Typography,
  Dialog,
  DialogTitle,
  IconButton
} from "@mui/material";
import { useField } from "@unform/core";
import React, { useEffect, useMemo, useState } from "react";
import { styled } from '@mui/material/styles';
import CloseIcon from '@mui/icons-material/Close';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import { UtilidadeService } from "../../services/api/utilidades/UtilidadesService";


const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));

export interface DialogTitleProps {
  id: string;
  children?: React.ReactNode;
  onClose: () => void;
}

function BootstrapDialogTitle(props: DialogTitleProps) {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
}

export interface IDadosModal {
  mensagem: string;
  label: string;
  titulo: string;
  acao: boolean;
  display: string;
  tipo: "error" | "warning" | "info" | "success";

}
export type IModalProps = {
  dados:IDadosModal;  
  isModalVisible: boolean;
  onBackClickClose: () => void;
}
export const DialogMensagem: React.FC<IModalProps> = ({dados, onBackClickClose, isModalVisible }) =>{ 
  const [open, setOpen] = React.useState(isModalVisible);

  if(!isModalVisible){
    return null;
  }
  const handleClickOpen = () => {
    setOpen(true);
    onBackClickClose();
  };
  const handleClose = () => {
    setOpen(false);
    onBackClickClose();
  };

  return (
    <div >
      <Button variant="outlined" onClick={handleClickOpen} sx={{ display: dados.display }}>
        {dados.label}
      </Button>
      <BootstrapDialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
      >
        <BootstrapDialogTitle id="customized-dialog-title" onClose={handleClose}>
          {dados.titulo}
        </BootstrapDialogTitle>
        <DialogContent dividers sx={{ minWidth: UtilidadeService.isMobile() ? "300px" : "400px" }}>
          {dados.tipo === "error" ?
            <Alert severity="error" style={{ fontSize: UtilidadeService.isMobile() ? 13 : "auto" }}>{dados.mensagem}</Alert>
            : dados.tipo === "warning" ?
              <Alert severity="warning" style={{ fontSize: UtilidadeService.isMobile() ? 13 : "auto" }}>{dados.mensagem}</Alert>
              : dados.tipo === "info" ?
                <Alert severity="info" style={{ fontSize: UtilidadeService.isMobile() ? 13 : "auto" }}>{dados.mensagem}</Alert>
                : dados.tipo === "success" ?
                  <Alert severity="success" style={{ fontSize: UtilidadeService.isMobile() ? 13 : "auto" }}>{dados.mensagem}</Alert>
                  : dados.mensagem
          }
        </DialogContent>
        <DialogActions>
          <Button autoFocus onClick={handleClose}>
            Fechar
          </Button>
        </DialogActions>
      </BootstrapDialog>
    </div>
  )
};